import { capitalize } from 'lodash'
import React, { FunctionComponent } from 'react'
import { PosologyUnit } from '../../../../../model/Posology'
import { HorizontalScroller, EntityCard, Chip, FormHeading } from '../../../../shared'
import { DipensingBlockProps } from './DispensingBlock.model'
import styles from './DispensingBlock.module.scss'

export const DispensingBlock: FunctionComponent<DipensingBlockProps> = ({
  drugs,
  posologyForm,
  disabled,
  availableAdministrationRoutes,
  setPosologyForm,
}) => {
  const setUnit = (unit: PosologyUnit) => {
    setPosologyForm({
      ...posologyForm,
      units: [...posologyForm.units.filter((_unit) => _unit.id !== unit.id), unit],
    })
  }

  const setAdministrationRoute = (value: string) => {
    setPosologyForm({ ...posologyForm, administrationRoute: value })
  }

  return (
    <EntityCard loading={false} inactive={false}>
      <div className={styles.dispensingBlockContainer}>
        <FormHeading headings={[{ icon: 'pills', label: 'Administration' }]} />
        {drugs.map((drug) => (
          <div className={styles.dispensingBlockSubPart} key={drug.id}>
            <HorizontalScroller
              renderTitle={() => (
                <span className={styles.dispensingBlockSubPartTitle}>
                  Unité {drugs.length > 1 && drug.name}
                </span>
              )}
            >
              <div className={styles.dispensingBlockSubPartTypes}>
                {drug.units.map(({ title, id }) => (
                  <Chip
                    label={capitalize(title)}
                    key={id}
                    selected={
                      posologyForm.units.find((unit) => unit.id === drug.id)?.value === title
                    }
                    onClick={() => setUnit({ id: drug.id, type: drug.type, value: title })}
                    renderLabel={(label) => (
                      <span className={styles.dispensingBlockSubPartTypeName}>{label}</span>
                    )}
                    disabled={disabled}
                    testId={`posology-dispensing-unit-${id}`}
                  />
                ))}
              </div>
            </HorizontalScroller>
          </div>
        ))}
        <div className={styles.dispensingBlockSubPart}>
          <HorizontalScroller
            renderTitle={() => <span className={styles.dispensingBlockSubPartTitle}>Voie</span>}
          >
            <div className={styles.dispensingBlockSubPartTypes}>
              {availableAdministrationRoutes.map(({ title, id }) => (
                <Chip
                  colorPreset="dark"
                  label={capitalize(title)}
                  key={id}
                  onClick={() => setAdministrationRoute(title)}
                  selected={posologyForm.administrationRoute === title}
                  renderLabel={(label) => (
                    <span className={styles.dispensingBlockSubPartTypeName}>{label}</span>
                  )}
                  disabled={disabled}
                  testId={`posology-dispensing-administration-${id}`}
                />
              ))}
            </div>
          </HorizontalScroller>
        </div>
      </div>
    </EntityCard>
  )
}
